import { mutatorAction } from 'satcheljs';
import InlineImageViewState from '../schema/InlineImageViewState';

const setObjectUrl = mutatorAction(
    'SetInlineImageObjectUrl',
    (viewState: InlineImageViewState, objectUrl: string, dataUrl: string) => {
        viewState.objectUrls[objectUrl] = dataUrl;
    }
);

export default function createObjectUrlForFileBlob(
    viewState: InlineImageViewState,
    file: File,
    dataUrl: string
) {
    const objectUrl = URL.createObjectURL(file);
    setObjectUrl(viewState, objectUrl, dataUrl);
    return objectUrl;
}
